<template>
    <div>
        <base-crud
                crudName="Departamentos"
                newText="Novo Registro"
                :table="departmentsTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
                :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                departmentsTable: 'departmentsTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'title', 'date', 'actions'],
                tableData: ['id', 'title', 'date', 'email'],
                options: {
                    filterByColumn: true,
                    filterable: ['id', 'title', 'date', 'email'],
                    sortable: ['id', 'title', 'date'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': 'ID',
                        'date' : 'Data',
                        'title' : 'Departamento',
                        'actions' : 'Ações'
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = [];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    },
                    templates: {
                        date: function(h, row, index) {
                            if(row.fixed == '1'){
                                return row.day + '/' + row.month
                            } else {
                                return moment(row.specific_date).format('DD/MM/YYYY')
                            }
                        },
                        responsible_id: function(h, row, index) {
                            return row.responsible.name;
                        },
                        miliseconds: function(h, row, index){
                            return msToTime(row.miliseconds)
                        }
                    },
                },
                endPoint: 'departments/',

                dataForm: {}
            }
        },
        components: {
            BaseCrud
        },
        methods: {
          query: function (query) {
                let columns = {
                    id: 'id',
                    title: 'title',
                    date: 'date'
                };
                let filters = '';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });

                return filters;
          }
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Departments/Crud.vue